import { render, staticRenderFns } from "./productionDetail.vue?vue&type=template&id=1eadf9a5&scoped=true"
import script from "./productionDetail.vue?vue&type=script&lang=js"
export * from "./productionDetail.vue?vue&type=script&lang=js"
import style0 from "../../../style/exchange-shop/pc/common.scss?vue&type=style&index=0&id=1eadf9a5&prod&lang=scss&scoped=true&external"
import style1 from "./productionDetail.vue?vue&type=style&index=1&id=1eadf9a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eadf9a5",
  null
  
)

export default component.exports